"use client";
import * as React from "react";
const SvgAssignmentRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 18", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M14.22 1.8h-3.71C10.13.76 9.16 0 8 0S5.87.76 5.5 1.8H1.77A1.8 1.8 0 0 0 0 3.6v12.6c0 .99.8 1.8 1.78 1.8h12.44A1.8 1.8 0 0 0 16 16.2V3.6c0-.99-.8-1.8-1.78-1.8M8 1.8c.49 0 .89.4.89.9s-.4.9-.89.9a.9.9 0 0 1-.89-.9c0-.5.4-.9.89-.9m.89 12.6H4.44a.9.9 0 0 1-.88-.9c0-.5.4-.9.88-.9H8.9c.49 0 .89.4.89.9s-.4.9-.9.9m2.68-3.6H4.44a.9.9 0 0 1-.88-.9c0-.5.4-.9.88-.9h7.12c.48 0 .88.4.88.9s-.4.9-.88.9m0-3.6H4.44a.9.9 0 0 1-.88-.9c0-.5.4-.9.88-.9h7.12c.48 0 .88.4.88.9s-.4.9-.88.9" }));
export {
  SvgAssignmentRound as default
};
